import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
import { Eye, EyeOff } from 'lucide-react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from './input';
function PasswordInput({ className, ref, ...props }) {
    const { t } = useTranslation();
    const [showPassword, setShowPassword] = React.useState(false);
    return (_jsxs("div", { className: "relative", children: [_jsx(Input, { type: showPassword ? 'text' : 'password', 
                // Edge draws its own reveal eye inside every password field; with ours
                // that is two eyes, and Edge's takes taps too.
                className: cn('pr-10 [&::-ms-clear]:hidden [&::-ms-reveal]:hidden', className), ref: ref, ...props }), _jsx("button", { type: "button", tabIndex: -1, "aria-label": showPassword ? t('aria.hidePassword') : t('aria.showPassword'), onClick: () => setShowPassword((prev) => !prev), className: "text-muted-foreground hover:text-foreground touch-hitbox absolute inset-y-0 right-0 flex w-10 items-center justify-center rounded-r-md", children: showPassword ? _jsx(EyeOff, { className: "h-4 w-4" }) : _jsx(Eye, { className: "h-4 w-4" }) })] }));
}
export { PasswordInput };
